// The map→overlay transform, held explicitly rather than recovered from the DOM.
//
// #main carries `scale(scale) translate(-x, -y)` and #overlay carries no transform
// at all, while the root svg's viewBox is centred on the origin. Overlay space is
// therefore just view space, and a node's overlay position is a two-line
// calculation from values autoSize already computes.
//
// Deriving it instead of calling getScreenCTM() matters because every such call
// flushes pending style and layout for the whole document — with tens of thousands
// of live SVG elements that costs tens to hundreds of milliseconds, and the frame
// loop was previously paying it once per tracked node.

export const camera = {
  scale: 1,
  x: 0,
  y: 0,
  viewWidth: 0,
  viewHeight: 0,
};

export function setViewport(width, height) {
  camera.viewWidth = width;
  camera.viewHeight = height;
}

export function setTransform(scale, x, y) {
  camera.scale = scale;
  camera.x = x;
  camera.y = y;
}

export function worldToViewX(wx) {
  return (wx - camera.x) * camera.scale;
}

export function worldToViewY(wy) {
  return (wy - camera.y) * camera.scale;
}

export function viewToWorldX(vx) {
  return vx / camera.scale + camera.x;
}

export function viewToWorldY(vy) {
  return vy / camera.scale + camera.y;
}

// Mutated in place and handed to per-frame callbacks, matching what the previous
// getScreenCTM-derived bounds provided.
const bounds = { x1: 0, y1: 0, x2: 0, y2: 0 };

export function viewBounds() {
  bounds.x1 = camera.viewWidth * -0.5;
  bounds.y1 = camera.viewHeight * -0.5;
  bounds.x2 = camera.viewWidth * 0.5;
  bounds.y2 = camera.viewHeight * 0.5;
  return bounds;
}

if (typeof window !== "undefined") {
  window.camera = camera;
}
